import { SousDispositif as SousDispositifAF } from '@/features/domaine/types/opco/Demande/AF/SousDispositif'
import { SousDispositif as SousDispositifCPRO } from '@/features/domaine/types/opco/Demande/CPRO/SousDispositif'
import { SousDispositif as SousDispositifPROA } from '@/features/domaine/types/opco/Demande/PROA/SousDispositif'
import { SousDispositif as SousDispositifFPE } from '@/features/domaine/types/opco/Demande/CXPI/SousDispositif'
import type { Dispositif } from './Dispositif'

export const dispositifSousDispositifMap = {
  CPRO: SousDispositifCPRO,
  CAPP: [] as const,
  PROA: SousDispositifPROA,
  AF: SousDispositifAF,
  FPE: SousDispositifFPE,
  // DR: [] as const,
} as const satisfies Record<Dispositif, readonly string[]>

export type DispositifSousDispositif<D extends Dispositif> = (typeof dispositifSousDispositifMap)[D][number]

/** Format backend: 'AF', 'FPE!CDPI', 'CPRO!PRODIAT', etc. */
export type DispositifOuCombine<D extends Dispositif = Dispositif> = D | `${D}!${DispositifSousDispositif<D>}`
